import { InjectionToken } from "@angular/core";
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

const msalConfig = {
  auth: {
    clientId: environment.adConfig.clientId,
    authority: `https://login.microsoftonline.com/${environment.adConfig.tenantId}`,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) { return; }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

let msalInstance: PublicClientApplication | null = null;

export async function initializeMsalInstance() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
  }
  return msalInstance;
}

export function MSALInstanceFactory() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
    // Do NOT call initialize here, only in main.ts
  }
  return msalInstance;
}

export const b2cPolicies = {
  names: {
    signIn: 'B2C_1_susi',
  },
  authorities: {
    signIn: {
      authority:
        `https://login.microsoftonline.com/${environment.adConfig.tenantId}`,
    }
  },
  authorityDomain: 'https://login.microsoftonline.com/',
};

